import { css } from "emotion";
import H3 from "../../../../components/global/H3";
import H4 from "../../../../components/global/H4";
import P from "../../../../components/global/P";
import Image from "../../../../components/Image";
import { max } from "../../../../utils/CssUtils";
import FlexRow from "./FlexRow";

const wrapper = css({
  padding: "0 80px 72px 80px",
  textAlign: "center",
  margin: "auto",
  [max(600)]: {
    padding: "0 15px 40px 15px"
  },
  h3: {
    fontSize: 26,
    [max(600)]: {
      fontSize: 20
    },
    marginBottom: 48
  },
  h4: {
    marginBottom: 12,
    "&::first-letter": {
      textTransform: "capitalize"
    },
    textTransform: "lowercase",
    [max(600)]: {
      marginBottom: 8
    }
  },
  p: {
    marginBottom: 12,
    maxWidth: 440
  }
});

const flexWrapper = css({
  alignItems: "stretch",
  [max(600)]: {
    alignItems: "center"
  }
});

const HowWeDeliver = ({ header, data = [] }) => {
  const imageStyles = css({
    marginBottom: 24,
    width: 130,
    height: 125,
    verticalAlign: "middle",
    objectFit: "contain",
    [max(600)]: {
      width: 100,
      maxHeight: 95
    }
  });

  return (
    <div className={wrapper}>
      <div>
        <H3>{header}</H3>
        <FlexRow spacing={100} mobileSpacing={32} className={flexWrapper}>
          {data.map(item => (
            <div>
              <Image
                alt={item.alt}
                imageURL={item.image}
                styleSheet={imageStyles}
              />
              <H4>{item.title}</H4>
              <P>{item.content}</P>
            </div>
          ))}
        </FlexRow>
      </div>
    </div>
  );
};

export default HowWeDeliver;
